/**
 * Platform-admin routes — for users with role=platform_admin who manage
 * tenant clinics + view cross-tenant revenue.
 */
import React from 'react';
import { Route } from 'react-router-dom';
import PlatformHome from '../pages/admin/PlatformHome';
import PlatformClinics from '../pages/admin/PlatformClinics';
import PlatformRevenue from '../pages/admin/PlatformRevenue';
import PlatformSubscribers from '../pages/admin/PlatformSubscribers';
import PlatformSubscriberDetail from '../pages/admin/PlatformSubscriberDetail';
import PlatformPurgeUser from '../pages/admin/PlatformPurgeUser';

export const platformRoutes = (
  <>
    <Route path="/platform" element={<PlatformHome />} />
    <Route path="/platform/clinics" element={<PlatformClinics />} />
    <Route path="/platform/revenue" element={<PlatformRevenue />} />
    <Route path="/platform/subscribers" element={<PlatformSubscribers />} />
    <Route path="/platform/subscribers/:clinicId" element={<PlatformSubscriberDetail />} />
    <Route path="/platform/users" element={<PlatformPurgeUser />} />
  </>
);
